import { type ComponentType, type ReactElement } from "react";
import {
  ComputerIcon,
  FileIcon,
  HelpIcon,
  LoginIcon,
  NotificationIcon,
  RotateLockIcon,
  Users01Icon,
} from "vega-icons";

import { m } from "@vega-core/paraglide/messages";

import { Display } from "./sections/Display";
import { LoginHistory } from "./sections/LoginHistory";
import { MyAccess } from "./sections/MyAccess/MyAccess";
import { Notifications } from "./sections/Notifications/Notifications";
import { Profile } from "./sections/Profile";
import { Support } from "./sections/Support";
import { UserManagement } from "./sections/UserManagement/UserManagement";
import { UserProfile } from "./sections/UserManagement/UserProfile/UserProfile";
import { SettingsSection } from "./constants";

export type SettingsEntry = {
  section: SettingsSection;
  label: () => string;
  icon: ReactElement;
  component: ComponentType;
  group: "account" | "organization";
  visibility?: {
    hideForLPCoInvest?: boolean;
    featureFlag?: string;
  };
  children?: {
    path: string;
    component: ComponentType;
  }[];
};

export const settingsConfig: SettingsEntry[] = [
  {
    section: SettingsSection.PersonalDetails,
    label: () => m.settings_titles_profile(),
    icon: <FileIcon className="text-text/primary" />,
    component: Profile,
    group: "account",
  },
  {
    section: SettingsSection.Display,
    label: () => m.settings_titles_display(),
    icon: <ComputerIcon />,
    component: Display,
    group: "account",
  },
  {
    section: SettingsSection.Notifications,
    label: () => m.titles_notifications(),
    icon: <NotificationIcon />,
    component: Notifications,
    group: "account",
    visibility: { hideForLPCoInvest: true },
  },
  {
    section: SettingsSection.LoginHistory,
    label: () => m.settings_titles_loginHistory(),
    icon: <LoginIcon />,
    component: LoginHistory,
    group: "account",
    visibility: { featureFlag: "lp_settings_tab_security" },
  },
  {
    section: SettingsSection.Support,
    label: () => m.settings_titles_support(),
    icon: <HelpIcon />,
    component: Support,
    group: "account",
  },
  {
    section: SettingsSection.MyAccess,
    label: () => m.navTitles_myAccess(),
    icon: <RotateLockIcon className="text-text/primary" />,
    component: MyAccess,
    group: "organization",
    visibility: { hideForLPCoInvest: true },
  },
  {
    section: SettingsSection.Users,
    label: () => m.settings_titles_users(),
    icon: <Users01Icon />,
    component: UserManagement,
    group: "organization",
    visibility: { hideForLPCoInvest: true },
    children: [
      {
        path: ":id",
        component: UserProfile,
      },
    ],
  },
];
